import { render, staticRenderFns } from "./productsCategories.vue?vue&type=template&id=2c798446&scoped=true&"
import script from "./productsCategories.vue?vue&type=script&lang=js&"
export * from "./productsCategories.vue?vue&type=script&lang=js&"
import style0 from "./productsCategories.vue?vue&type=style&index=0&id=2c798446&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c798446",
  null
  
)

export default component.exports